import { Hero } from "../components/home/Hero";
import { Manifesto } from "../components/home/Manifesto";
import { Selection } from "../components/home/Selection";
import { Vision } from "../components/home/Vision";
import { Objects } from "../components/home/Objects";
import { ProcessStrip, Closing } from "../components/home/ProcessStrip";
import { useSeo } from "../components/site/Seo";
import { useLang } from "../i18n/lang";

export default function Home() {
  const { t } = useLang();
  useSeo(...t.seo.home);
  return (
    <main data-testid="home-page">
      <Hero />
      <Manifesto />
      <Selection />
      <Vision />
      <Objects />
      <ProcessStrip />
      <Closing />
    </main>
  );
}
